import { Button } from "@mantine/core";

const TinyButton = ({ children, ...rest }) => (
  <Button variant="outline" radius="xl" size="xs" compact {...rest}>
    {children}
  </Button>
);

export default TinyButton;
